// extracted by mini-css-extract-plugin
module.exports = {"takeTurns":"TakeTurns_takeTurns__1oXKw"};